import { localTokenFactory } from '@dandi/core'

export const localToken = localTokenFactory('@dandi/cache')
